/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm, useTranslate } from 'react-admin';
import CourseForm from './CourseForm';
import courseStatus from '../../enums/course-status.enum';
import customEdit from './edit';
import customCreate from './create';

const CourseDetail = (props) => {
  const { actionType, basePath } = props;
  const translate = useTranslate();
  const statusLabel = translate('custom.general.status');
  const nameLabel = translate('custom.general.name');
  const clientsLabel = translate('custom.clients.title');
  const licenseLabel = translate('custom.licenses.title');
  const resourceText = translate('custom.courses.resource');
  const updatedText = translate('custom.courses.updated');
  const createdText = translate('custom.courses.created');
  const edit = useCallback(
    customEdit({
      basePath,
      resourceText,
      updatedText,
    })
  );
  const create = useCallback(
    customCreate({
      basePath,
      resourceText,
      createdText,
    })
  );
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm save={edit}>
            <CourseForm
              status={courseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              clientsLabel={clientsLabel}
              licenseLabel={licenseLabel}
            />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm save={create}>
            <CourseForm
              status={courseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              clientsLabel={clientsLabel}
              licenseLabel={licenseLabel}
            />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

CourseDetail.propTypes = {
  actionType: PropTypes.string,
  basePath: PropTypes.string.isRequired,
};

CourseDetail.defaultProps = {
  actionType: 'create',
};

export default CourseDetail;
